import { ThirdPartyConfigs } from '../constants/3p-product-configs';
import { ProductKeys3P, PRODUCTS_ORDER, type ProductKeys } from '../constants/products';
import {
	isForgeConnectorProductKey,
	type ThirdPartyConfigsBootstrap,
} from '../constants/schemas/3p-config';

interface GetOrderedAvailableProductsProps {
	isOnSearchDialog: boolean;
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProducts: ProductKeys[];
}

export const getOrderedAvailableProducts = ({
	isOnSearchDialog,
	thirdPartyConfigs,
	availableProducts,
}: GetOrderedAvailableProductsProps): string[] => {
	let productOrder: ProductKeys[] = [];

	if (isOnSearchDialog) {
		// TODO: we should consolidate the behaviour of banners between FPS and QF (both order and what products are shown).
		// See https://atlassian.slack.com/archives/C0A8GKLU6PQ/p1770850523754429
		productOrder = [
			ProductKeys3P.GoogleDrive,
			ProductKeys3P.Sharepoint,
			ProductKeys3P.Slack,
			ProductKeys3P.Teams,
			ProductKeys3P.Github,
			ProductKeys3P.Figma,
			ProductKeys3P.Gitbook,
		];
	} else {
		const requiredProducts: ProductKeys[] = [];

		ThirdPartyConfigs.forEach((_, productKey3P) => {
			if (ThirdPartyConfigs.get(productKey3P)?.requiresOauth) {
				requiredProducts.push(productKey3P);
			}
		});

		// Filter and order static products based on PRODUCTS_ORDER
		const staticProducts = PRODUCTS_ORDER.filter((product) => requiredProducts.includes(product));

		// Add Forge connectors that need OAuth (ordered after static products)
		const forgeConnectors = availableProducts.filter(
			(product) =>
				isForgeConnectorProductKey(product) &&
				thirdPartyConfigs[product]?.userNeedsOAuth &&
				thirdPartyConfigs[product]?.outboundAuthUrl,
		);

		productOrder = [...staticProducts, ...forgeConnectors];
	}

	return productOrder.filter((product) => availableProducts.includes(product));
};
